import { Head, Link } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { Badge } from "@/components/ui/badge"

type ScorecardRow = {
  id: number
  token: string
  email: string
  name: string | null
  grade: string
  kit_synced: boolean
  has_error: boolean
  created_at: string
}

export default function AdminPodcastScorecardsIndex({ scorecards }: { scorecards: ScorecardRow[] }) {
  return (
    <>
      <Head title="Podcast Scorecards">
        <meta name="description" content="Podcast scorecard leads captured by the free scorecard tool." />
        <meta property="og:title" content="Podcast Scorecards" />
        <meta property="og:description" content="Podcast scorecard leads captured by the free scorecard tool." />
      </Head>
      <AdminShell>
        <div className="border-b border-hairline pb-6">
          <h1>Podcast Scorecards</h1>
          <p className="mt-1">
            {scorecards.length} {scorecards.length === 1 ? "scorecard" : "scorecards"} taken
            via the free strategy tool. Each one is a lead.
          </p>
        </div>

        {scorecards.length === 0 ? (
          <p className="mt-10 text-ink-muted">No scorecards yet.</p>
        ) : (
          <div className="mt-6 overflow-x-auto rounded-md border border-hairline">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-hairline bg-surface text-left">
                  <th className="px-4 py-3 font-medium text-ink-muted">Email</th>
                  <th className="px-4 py-3 font-medium text-ink-muted">Name</th>
                  <th className="px-4 py-3 font-medium text-ink-muted">Grade</th>
                  <th className="px-4 py-3 font-medium text-ink-muted">Kit</th>
                  <th className="px-4 py-3 font-medium text-ink-muted">Taken</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-hairline">
                {scorecards.map((s) => (
                  <tr key={s.id} className="hover:bg-surface">
                    <td className="px-4 py-3">
                      <Link href={`/admin/podcast_scorecards/${s.id}`} className="text-ink-display underline-offset-2 hover:underline">
                        {s.email}
                      </Link>
                    </td>
                    <td className="px-4 py-3 text-ink-body">{s.name || "—"}</td>
                    <td className="px-4 py-3">
                      <Badge tone={s.grade === "pre-launch" ? "muted" : ["A", "B"].includes(s.grade) ? "signal" : ["C"].includes(s.grade) ? "muted" : "accent"}>
                        {s.grade}
                      </Badge>
                    </td>
                    <td className="px-4 py-3">
                      {s.has_error ? (
                        <Badge tone="accent">error</Badge>
                      ) : s.kit_synced ? (
                        <Badge tone="signal">synced</Badge>
                      ) : (
                        <Badge tone="muted">pending</Badge>
                      )}
                    </td>
                    <td className="px-4 py-3 text-ink-muted">
                      {new Date(s.created_at).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </AdminShell>
    </>
  )
}
